<template>
    <div class="receive-discuss">
        <div class="discuss-list">
            <div class="list-item" v-for="(item, index) in discussDataList" :key="index">
                <div class="item-left">
                    <img :src="item.avatar">
                </div>
                <div class="item-right">
                    <div class="item-name">{{item.nickname}}<template v-if="item.bereply"><span>回复</span>{{item.tonickname}}</template></div>
                    <p v-html="item.content"></p>
                    <div class="item-mix">
                        <div class="mix-left">
                            <span style="margin">{{item.ctime}}</span>
                            <span class="item-report" @click="commentReport(item.pid, item.cid, item.userid)">举报</span>
                        </div>
                        <div class="mix-right">
                            <span class="item-like" @click="commentLikes(item.pid, item.cid, item)">赞同({{item.likes}})</span>
                            <span>|</span>
                            <span @click="isShowInputDiscuss(index)">{{clickIndex !== index ? '回复' : '收起回复'}}</span>
                        </div>
                    </div>
                </div>
                <div class="input-discuss" v-show="index === clickIndex">
                    <textarea v-model="inputDiscuss" @keyup="changeInput"></textarea>
                    <button @click="submitDiscuss(item.pid, item.userid, item.cid, item)" :class="isdiscusscontent ? 'active' : ''">回复</button>
                </div>
            </div>
        </div>
        <div class="pagination-heart">
            <vue-pagination
                class="square-page"
                :page-size="pageSize"
                :total="total"
                @current-change="goPage">
            </vue-pagination>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'receive-discuss',
        mounted () {
            this.updateList()
        },
        props: {
            pid: {
                type: Number,
                required: true
            },
            sid: {
                type: Number,
                required: true
            }
        },
        computed: {
            discussDataList () {
                return this.discussResult.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
            }
        },
        data () {
            return {
                discussResult: [],
                currentPage: 1,
                pageSize: 10,
                total: 0,
                inputDiscuss: '',
                bereplyDiscuss: '',
                isdiscusscontent: false,
                isbereplycontent: false,
                clickIndex: -1,
                bereplyIndex: -1,
                countIndex: -1,
                reportIndex: -1,
                numIndex: -1
            }
        },
        methods: {
            commentLikes (pid, cid, item) {
                var self = this
                axios.get('/sns/commentlikes', {params: {
                    pid: pid,
                    cid: cid
                }}).then((res) => {
                    if (!res.data.result) {
                        self.$tip({
                            message: res.data.errormsg ? res.data.errormsg.toString() : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                    } else {
                        self.$tip({
                            message: '点赞成功',
                            duration: 2000,
                            type: 'success'
                        })
                        item.likes += 1
                    }
                }).catch((error) => {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            },
            commentReport (pid, cid, userid) {
                var self = this
                axios.get('/sns/commentreport', {params: {
                    pid: pid,
                    userid: userid,
                    cid: cid
                }}).then((res) => {
                    if (!res.data.errorcode) {
                        self.$tip({
                            message: res.data.errormsg ? res.data.errormsg.toString() : '举报成功，后台审核中',
                            duration: 2000,
                            type: 'success'
                        })
                    } else {
                        self.$tip({
                            message: '举报失败，请稍后再试',
                            duration: 2000,
                            type: 'error'
                        })
                    }
                }).catch((error) => {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            },
            changeInput () {
                if (!this.inputDiscuss) {
                    this.isdiscusscontent = false
                } else {
                    this.isdiscusscontent = true
                }
            },
            bereplyInput () {
                if (!this.bereplyDiscuss) {
                    this.isbereplycontent = false
                } else {
                    this.isbereplycontent = true
                }
            },
            isShowInputDiscuss (index) {
                if (this.clickIndex === index) {
                    this.clickIndex = -1
                } else {
                    this.clickIndex = index
                    this.inputDiscuss = ''
                }
            },
            isShowInputBereply (num, index) {
                if (this.bereplyIndex === num) {
                    this.bereplyIndex = -1
                    this.countIndex = -1
                } else {
                    this.bereplyIndex = num
                    this.countIndex = index
                    this.bereplyDiscuss = ''
                }
            },
            goPage (page) {
                this.currentPage = page
            },
            enter (num, index) {
                if (this.reportIndex === num) {
                    this.reportIndex = -1
                    this.numIndex = -1
                } else {
                    this.reportIndex = num
                    this.numIndex = index
                }
            },
            submitDiscuss (pid, userid, cid, item) {
                var self = this
                if (!this.inputDiscuss) {
                    self.$tip({
                        message: '回复内容不能为空',
                        duration: 2000,
                        type: 'error'
                    })
                } else {
                    window.TA.log(this.$buriedPoint.strategyDetails.strategyDiscuss.reply.replace('_square', '_square_' + this.strategyId))
                    axios.post('/sns/addcomment', {
                        pid: pid,
                        receiver_id: userid,
                        rid: cid,
                        content: this.inputDiscuss
                    }).then((res) => {
                        if (!res.data.result) {
                            self.$tip({
                                message: '回复失败，请稍后再试',
                                duration: 2000,
                                type: 'error'
                            })
                            self.inputDiscuss = ''
                        } else {
                            self.$tip({
                                message: '回复内容正在后台审核中',
                                duration: 2000,
                                type: 'success'
                            })
                            self.inputDiscuss = ''
                            self.$store.dispatch('myStrategy/requestSendDiscuss')
                        }
                    }).catch((error) => {
                        self.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                        self.inputDiscuss = ''
                    })
                }
            },
            submitBereply (pid, userid, cid, item) {
                var self = this
                if (!this.bereplyDiscuss) {
                    self.$tip({
                        message: '回复内容不能为空',
                        duration: 2000,
                        type: 'error'
                    })
                } else {
                    axios.post('/sns/addcomment', {
                        pid: pid,
                        receiver_id: userid,
                        rid: cid,
                        content: this.bereplyDiscuss
                    }).then((res) => {
                        if (!res.data.result) {
                            self.$tip({
                                message: '回复失败，请稍后再试',
                                duration: 2000,
                                type: 'error'
                            })
                            self.bereplyDiscuss = ''
                        } else {
                            self.$tip({
                                message: '回复内容正在后台审核中',
                                duration: 2000,
                                type: 'success'
                            })
                            self.bereplyDiscuss = ''
                            self.$store.dispatch('myStrategy/requestSendDiscuss')
                        }
                    }).catch((error) => {
                        self.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                        self.bereplyDiscuss = ''
                    })
                }
            },
            updateList () {
                var self = this
                axios.get('/sns/querycommentbypid', {params: {
                    sid: this.sid,
                    pid: this.pid,
                    page: this.currentPage,
                    pagesize: -1 // all
                }}).then((res) => {
                    if (res) {
                        if (res.data.errorcode === 0) {
                            self.discussResult = res.data.result
                            self.total = self.discussResult.length
                            self.currentPage = 1
                        }
                    }
                }).catch((error) => {
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            }
        },
        watch: {
            pid () {
                this.updateList()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/strategysquare/receive-discuss.scss';
</style>



// WEBPACK FOOTER //
// src/components/strategysquare/receive-discuss.vue